import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["stroke", "size"],
    _excluded2 = ["stroke", "size"],
    _excluded3 = ["stroke", "size"],
    _excluded4 = ["stroke", "size"],
    _excluded5 = ["stroke", "size"];
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { memo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var BarIcon = /*#__PURE__*/memo(function (_ref) {
  var _ref$stroke = _ref.stroke,
      stroke = _ref$stroke === void 0 ? '#6B7280' : _ref$stroke,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 20 : _ref$size,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 21"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      clipPath: "url(#clip0_2233_22680)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M14.438 11.44L9.014 6.01a1.747 1.747 0 010-2.47 1.74 1.74 0 012.463 0l5.539 5.544c.65.65.65 1.705 0 2.356-.712.71-1.866.71-2.578 0z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M11.746 8.744l-1.513 1.514a.626.626 0 01-.559.178l-1.44-.29a.417.417 0 00-.422.65l1.776 2.487c.24.337-.104.78-.49.631L5.51 12.528c-.389-.15-.733.302-.485.637L7.2 16.097a.417.417 0 01-.417.656l-2.21-.445a.623.623 0 00-.56.178L2.5 17.999"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2233_22680",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H20V20H0z",
          transform: "translate(0 .5)"
        })
      })
    })]
  }));
});
export var CucinaIcon = /*#__PURE__*/memo(function (_ref2) {
  var _ref2$stroke = _ref2.stroke,
      stroke = _ref2$stroke === void 0 ? '#6B7280' : _ref2$stroke,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 20 : _ref2$size,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 18 17"
  }, rest), {}, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M3.998 9.152c-.83-.159-1.613-.623-2.106-1.48a3.013 3.013 0 01.156-3.22c.936-1.3 2.603-1.612 3.913-.976C6.231 2.067 7.487 1 9.001 1s2.77 1.067 3.04 2.476c1.307-.634 2.97-.325 3.906.966.674.93.734 2.22.168 3.219-.493.868-1.277 1.329-2.11 1.487l-.006 5.185c-.001.92-.747 1.665-1.667 1.665L5.66 16a1.666 1.666 0 01-1.667-1.668l.006-5.18zM14 12.25H4"
    })
  }));
});
export var SalaIcon = /*#__PURE__*/memo(function (_ref3) {
  var _ref3$stroke = _ref3.stroke,
      stroke = _ref3$stroke === void 0 ? '#6B7280' : _ref3$stroke,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 20 : _ref3$size,
      rest = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 21"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M16.482 17.752H3.517a.833.833 0 01-.79-.57l-.644-1.93h15.833l-.643 1.93a.833.833 0 01-.79.57z"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M2.55 15.252l-.04-.799A7.5 7.5 0 0110 6.58v0a7.5 7.5 0 017.491 7.873l-.04.799"
    }), /*#__PURE__*/_jsx("path", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      d: "M10 6.58c-.921 0-1.667-.745-1.667-1.666v-.247a1.666 1.666 0 113.333 0v.247c0 .92-.745 1.667-1.666 1.667z"
    })]
  }));
});
export var ReceptionIcon = /*#__PURE__*/memo(function (_ref4) {
  var _ref4$stroke = _ref4.stroke,
      stroke = _ref4$stroke === void 0 ? '#6B7280' : _ref4$stroke,
      _ref4$size = _ref4.size,
      size = _ref4$size === void 0 ? 20 : _ref4$size,
      rest = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: "none",
    viewBox: "0 0 20 21"
  }, rest), {}, {
    children: [/*#__PURE__*/_jsx("g", {
      stroke: stroke,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      clipPath: "url(#clip0_2392_24677)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M13.334 6.334H6.667M8.334 3h3.333a1.667 1.667 0 011.667 1.667V8a3.333 3.333 0 11-6.667 0V4.667A1.667 1.667 0 018.334 3zM7.5 13.416l-3.042.608A2.436 2.436 0 002.5 16.413v1.586M10.041 14.667a.042.042 0 01-.05.04.041.041 0 01-.032-.032.042.042 0 01.04-.05.042.042 0 01.042.042M10.041 17.167a.042.042 0 01-.05.04.041.041 0 01-.032-.032.042.042 0 01.04-.05.042.042 0 01.042.042M12.5 13.416l3.042.608a2.436 2.436 0 011.958 2.389v1.586"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_2392_24677",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0H20V20H0z",
          transform: "translate(0 .5)"
        })
      })
    })]
  }));
});
export var ClipBoardCopyIcon = /*#__PURE__*/memo(function (_ref5) {
  var _ref5$stroke = _ref5.stroke,
      stroke = _ref5$stroke === void 0 ? '#6B7280' : _ref5$stroke,
      _ref5$size = _ref5.size,
      size = _ref5$size === void 0 ? 20 : _ref5$size,
      rest = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 20 21",
    fill: "none"
  }, rest), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M6.66732 4.66667H5.00065C4.55862 4.66667 4.1347 4.84226 3.82214 5.15482C3.50958 5.46738 3.33398 5.89131 3.33398 6.33333V16.3333C3.33398 16.7754 3.50958 17.1993 3.82214 17.5118C4.1347 17.8244 4.55862 18 5.00065 18H13.334C13.776 18 14.1999 17.8244 14.5125 17.5118C14.8251 17.1993 15.0007 16.7754 15.0007 16.3333V15.5M6.66732 4.66667C6.66732 5.10869 6.84291 5.53262 7.15547 5.84518C7.46803 6.15774 7.89196 6.33333 8.33398 6.33333H10.0007C10.4427 6.33333 10.8666 6.15774 11.1792 5.84518C11.4917 5.53262 11.6673 5.10869 11.6673 4.66667M6.66732 4.66667C6.66732 4.22464 6.84291 3.80072 7.15547 3.48816C7.46803 3.17559 7.89196 3 8.33398 3H10.0007C10.4427 3 10.8666 3.17559 11.1792 3.48816C11.4917 3.80072 11.6673 4.22464 11.6673 4.66667M11.6673 4.66667H13.334C13.776 4.66667 14.1999 4.84226 14.5125 5.15482C14.8251 5.46738 15.0007 5.89131 15.0007 6.33333V8.83333M16.6673 12.1667H8.33398M8.33398 12.1667L10.834 9.66667M8.33398 12.1667L10.834 14.6667",
      stroke: stroke,
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  }));
});